import { createGenericContext } from '@savgroup-front-common/core/helpers';

import { AppContextArgs } from './App.context.types';

export const [useAppContext, AppProvider] =
  createGenericContext<AppContextArgs>();
